<template>
  <div class="personality-socially-fluent-content" id="plataforma-de-marca-personalidade-socialmente-fluentes" data-search-anchor>
    <div class="personality-socially-fluent-overlay-title-image">
      <h1 class="personality-socially-fluent-image-technology-title">
        {{ PersonalitySocialFluentImageTitle }}
      </h1>
      <p class="personality-socially-fluent-image-technology-text">
        {{ PersonalitySocialFluentImageTitle2}}
      </p>
    </div>

    <div
      class="personality-socially-fluent-banner-image"
      :style="{ backgroundImage: `url(${PersonalitySocialFluentImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalitySociallyFluentSection extends Mixins(PersonalityPageMixin) {
  personalityPageStore: PageStoreContract = getModule(PersonalityPageStore, this.$store)

  get PersonalitySocialFluentImageTitle(): string {
    return this.getElementText(2, 0)
  }

  get PersonalitySocialFluentImageSrc(): string {
    return this.getElementMedia(2, 0)
  }

  get PersonalitySocialFluentImageTitle2(): string {
    return this.getElementText(2, 1)
  }

  get F(): string {
    return this.getElementText(2, 2)
  }

  async getPersonalityPageStore(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPageStore()
    }
  }
}
</script>

<style lang="scss">
.personality-socially-fluent-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;     
}

.personality-socially-fluent-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.personality-socially-fluent-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.personality-socially-fluent-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 4rem;
}

.personality-socially-fluent-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
